import {Group, Wedge} from "react-konva";
import {PIXELS_PER_METER} from "@/dungeons/geometry/Coordinates.ts";
import type {VisibleArea} from "./VisibilityModel.ts";
import {SIGHT_CONE_HALF_ANGLE_DEGREES} from "./SightModel.ts";

export default function VisibilityPreview({areas, radiusMeters, color}: {
    areas: VisibleArea[];
    radiusMeters: number;
    color: string;
}) {
    return <>{areas.filter(area => area.polygon.length >= 3).map((area, index) =>
        <Group key={index} clipFunc={context => {
            context.beginPath();
            context.moveTo(area.polygon[0].x, area.polygon[0].y);
            area.polygon.slice(1).forEach(point => context.lineTo(point.x, point.y));
            context.closePath();
        }} listening={false}>
            <Wedge x={area.origin.x} y={area.origin.y} radius={radiusMeters * PIXELS_PER_METER}
                   angle={SIGHT_CONE_HALF_ANGLE_DEGREES * 2}
                   rotation={area.rotationDegrees - SIGHT_CONE_HALF_ANGLE_DEGREES}
                   fill={color} opacity={0.25} listening={false}/>
        </Group>
    )}</>;
}
